<template>
  <v-card outlined fill-height class="overflow-hidden card-top-main">
    <v-card-text class="pa-0 d-block" style="font-family: Roboto, sans-serif">
      <slot name="body">
        <!-- {{}} -->
      </slot>
    </v-card-text>
    <i-button-list v-if="useBtnList.length > 0"
      :key="btnKey" :useBtnList="useBtnList" :unUseBtnList="unUseBtnList" :customBtnList="customBtnList" @btnClick="clickButton" class="d-block py-2 pr-3 pl-1 pl-md-0 btn_list"  />
  </v-card>
</template>

<script>
import iButtonList from '../common/iButtonList.vue'

export default {
  name: 'i-card-top',
  components: {
    iButtonList
  },
  props: {
    headerTitle: {
      type: String,
      default: '제목'
    },
    color: {
      type: String,
      default: 'card_bg'
    },
    divider: {
      type: Boolean,
      default: false
    },
    // 버튼 리스트
    useBtnList: {
      type: Array,
      default: () => ['']
    },
    unUseBtnList: {
      type: Array,
      default: () => ['']
    },
    customBtnList: {
      type: Array,
      default: () => []
    },
    btnKey: {
      type: Number,
      default: 0
    }
  },
  methods: {
    // 버튼 클릭 시 각 id별로 이벤트생성
    clickButton(targetButton) {
      this.$emit(targetButton.id, targetButton.role)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  // background: #ecedf3;
  background-color: #E2EBE9;
  //margin-bottom: 22px;
}
</style>
